export const FONT_VAR_AXIS = [
    'ital',
    'opsz',
    'slnt',
    'wdth',
    'wght',
    'custom',
] as const;
export type FontVarAxis = (typeof FONT_VAR_AXIS)[number];

export function isFontVarAxis(value: unknown): value is FontVarAxis {
    return FONT_VAR_AXIS.includes(value as FontVarAxis);
}

export const FONT_VAR_AXIS_OPTIONS = [
    { value: 'ital', label: 'Italic' },
    { value: 'opsz', label: 'Optical Size' },
    { value: 'slnt', label: 'Slant' },
    { value: 'wdth', label: 'Width' },
    { value: 'wght', label: 'Weight' },
    { value: 'custom', label: 'Custom' },
] as const;
